import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import { Accordion as ExpansionPanel, AccordionDetails as ExpansionPanelDetails, AccordionSummary as ExpansionPanelSummary, Button, Grid, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React from 'react';
import SearchToolBarItems from '../SearchToolBarItems';

const useStyles = makeStyles((theme) => createStyles({
  root: {
    width: '100%',
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  details: {
    alignItems: 'center',
    width: '100%',
  },
  column: {
    flexBasis: '33.33%',
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const SearchToolbar = props => {
  const classes = useStyles();
  const { onSubmit, ...rest } = props;

  return (
    <div className={classes.root}>
      <ExpansionPanel >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1c-content"
          id="panel1c-header"
        >
          <Grid container   
          alignItems="center"
          justify="center"
          spacing={3}>
          <Grid item xs={4}>
          <div className={classes.column}>
          <Typography className={classes.secondaryHeading}>Select Search Parameters</Typography>
          </div>
          </Grid>
          <Grid item xs={6}>
          <div className={classes.column}/>
          
          </Grid>
          <Grid item xs={2}>

          <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick = {onSubmit} /** es6 **/
        endIcon={<SearchIcon/>}>
          Search
        </Button>
          </Grid>
          </Grid>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.details}>
        <SearchToolBarItems 
        {...rest}
        />
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
}

export default SearchToolbar